import { EChoirDenomination, EChoirGoal, EChoirLevel, EChoirStyle, ERepertoirNature, EWayOfSinging } from "../../../../../common/types/choir/meta/general";
import messages from "./messages";

export const choirLevelOptions = [
    {
        value: EChoirLevel.BIGINNER,
        label: messages.beginner,
    },
    {
        value: EChoirLevel.INTERMEDIATE,
        label: messages.intermediate,
    },
    {
        value: EChoirLevel.ADVANCED,
        label: messages.advanced,
    },
];

export const choirGoalOptions = [
    {
        value: EChoirGoal.CONCERT,
        label: messages.concert
    },
    {
        value: EChoirGoal.RECORDING,
        label: messages.recording
    },
    {
        value: EChoirGoal.JOYFUL_MUSIC,
        label: messages.joyfulMusic
    },
    {
        value: EChoirGoal.BLATT_NIGHT,
        label: messages.blattNight
    },
];

export const choirRepertoriNatureOptions = [
    {
        value: ERepertoirNature.CHURCH,
        label: messages.church
    },
    {
        value: ERepertoirNature.SECULAR,
        label: messages.secular
    },
];

export const choirStyleOptions = [
    {
        value: EChoirStyle.CLASSICAL_CHOIR,
        label: messages.classicalChoir
    },
    {
        value: EChoirStyle.RENAISSANCE_MADRIGAL,
        label: messages.renaissanceMadrigal
    },
    {
        value: EChoirStyle.ORATORIO,
        label: messages.oratorio
    },
    {
        value: EChoirStyle.MOTET,
        label: messages.motet
    },
    {
        value: EChoirStyle.GOSPEL,
        label: messages.gospel
    },
    {
        value: EChoirStyle.POP,
        label: messages.pop
    },
    {
        value: EChoirStyle.ROCK,
        label: messages.rock
    },
    {
        value: EChoirStyle.JAZZ,
        label: messages.jazz
    },
    {
        value: EChoirStyle.FOLK,
        label: messages.folk
    },
    {
        value: EChoirStyle.WORLD,
        label: messages.world
    },
    {
        value: EChoirStyle.MODERN_CHOIR,
        label: messages.modernChoir
    },
    {
        value: EChoirStyle.EXPERIMENTAL,
        label: messages.experimental
    },
    {
        value: EChoirStyle.ELECTRONIC,
        label: messages.electronic
    },
    {
        value: EChoirStyle.OTHER,
        label: messages.other
    },
];

export const choirWayOfSingingOptions = [
    {
        value: EWayOfSinging.SCORE,
        label: messages.score
    },
    {
        value: EWayOfSinging.BY_HEART,
        label: messages.byHeart
    },
]

export const choirDenominationOptions = [
    {
        value: EChoirDenomination.CATHOLIC,
        label: messages.catholic
    },
    {
        value: EChoirDenomination.REFORMED,
        label: messages.reformed
    },
    {
        value: EChoirDenomination.LUTHERAN,
        label: messages.lutheran
    },
    {
        value: EChoirDenomination.GREEK_CATHOLIC,
        label: messages.greekCatholic
    },
    {
        value: EChoirDenomination.BAPTIST,
        label: messages.baptist
    },
    {
        value: EChoirDenomination.METHODIST,
        label: messages.methodist
    },
]